
import { connect } from 'react-redux';
import { IApplicationState } from '../../../ducks/reducers';
import { selectors as operationSelectors } from '../../../ducks/uiOperations';
import { selectors as uiSelectors } from '../../../ducks/ui';
import { selectors as formSelectors } from '../../../ducks/form';
import { selectors as productDetailsSelectors } from '../../../ducks/inventoryEnquiry/productDetails';
import { selectors as productSelectors } from '../../../ducks/SearchLookUp/productLookup';

import ProductDetails from './ProductDetails';

const mapStateToProps = (state: IApplicationState) => ({
  operationMode: operationSelectors.operationMode(state),
  selectedTab: uiSelectors.selectedTab(state),
  selectedForm: formSelectors.selected(state),
  isBrowseLookUpOpen: uiSelectors.isBrowseLookUpOpen(state),
  selectedProduct: productSelectors.selected(state),
  productDetails: productDetailsSelectors.productDetails(state),
  productDetailsSchema: productDetailsSelectors.productDetailsSchema(state),
});

export default connect(mapStateToProps, {})(ProductDetails);
